module.exports = __webpack_public_path__ + "img/cog.32d903aa.svg";